import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
  Validator
} from 'vee-validate';
import {
  BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading'
// import { Line, mixins } from 'vue-chartjs'
// import MonthlySalesChart from './MonthlySalesChart';
import PageTracker from '../../../common/PageTrackerHelper'


export default {
  name: 'dashboard',
  components: {BasicSelect,VueElementLoading
},
  props: [],
  mixins:[PageTracker],
  data() {
    return {
      client:'',
      clientList:[],
      srLoader :'',
      loader:'<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
      srArrayList : [],
      clientArrayList : [],
      srList : [],
      srListFlt :[],
      srItemObj:{ value: "",text: ""},
      clientItemObj:{ value: "",text: ""},
      srId:'',
      userHubId:'',
      Total: {
        DeliveryTotalCount: 0,
        RVPTotalCount: 0,
        DTOTotalCount: 0,
        RTOTotalCount: 0
      },
      Delivery: {
       AllocatedCount: 0,
       OFDCount: 0,
       NDRCount: 0,
       DeliveredCount: 0
      },
     RVP: {
         AllocatedCount: 0,
         OFDCount: 0,
         NDRCount: 0,
         PickDoneCount: 0
     },
     DTO: {
         AllocatedCount: 0,
         OFDCount: 0,
         DTOCount: 0,
         NDRCount: 0
     },
     RTO: {
       OFDCount: 0,
       AllocatedCount: 0,
       NDRCount: 0,
       RTOCount: 0
     },
      systemUserCount: 0,
      appUserCount: 0,
      systemRoleCount: 0,
      appRoleCount: 0,
      totalProjectCount: 0,
      clientusers:0,
      adminuser:0,
      deliverycount:0,
      clientvendorcount:0,
      getstatusName:'DELIVERY',
      getday: '',
      datacollection: null,
      thirdOptionForShipmentType:'Delivery',
      SRallocatedCount:0,
      OfdCount:0,
      deliveryCount:0,
      NdrCount:0,
      TotalCount :0,
      TopSRs:[],
      IsTopSRs:false
    }
  },
  computed: {

  },
  async mounted() {
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes  = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail =JSON.parse(plaintext);
    this.username = userdetail.username;
    this.userid = userdetail.userid;
    this.userHubId = userdetail.hubdetails[0] == undefined ? 0 : userdetail.hubdetails[0]
    // var userToken = window.localStorage.getItem('userToken')
    // this.myStr = userToken.replace(/"/g, '');
    // this.getRoleCount();
    // this.getUsersCount();
    // this.getProjectsCount();
    this.loadSRList(this.userHubId)
    this.getClientList();
    this.GetDashboardDetails('DELIVERY')
    //this.GetstatusData('DELIVERY')
    this.GetTopSRList('day')
    this.fillData()
    //console.log('Mixin is working for :',result);
  },
  methods: {
    fillData () {
        this.datacollection = {
          labels: [this.getRandomInt(), this.getRandomInt()],
          datasets: [
            {
              label: 'Data One',
              backgroundColor: '#f87979',
              data: [this.getRandomInt(), this.getRandomInt()]
            }, {
              label: 'Data One',
              backgroundColor: '#f87979',
              data: [this.getRandomInt(), this.getRandomInt()]
            }
          ]
        }
      },
      getRandomInt () {
        return Math.floor(Math.random() * (50 - 5 + 1)) + 5
      },
    getclients(obj){
    this.clientItemObj = obj
    this.client = this.clientItemObj.value
    this.GetDashboardDetails()
  },
    getSRs(obj){
      this.srItemObj = obj
      this.srId = this.srItemObj.value
      this.GetDashboardDetails()
    },

    async GetDashboardDetails(getstatusName){

      let todaydate = moment().format('YYYY-MM-DD');
      let serchData = {
        "HubId":this.userHubId,
        "AssignDate": todaydate//"2020-03-02"
      }
      if(this.srId){
       serchData.DeliveryUserId = this.srId
      }
      if(this.client){
        serchData.ClientId = parseInt(this.client)
      }

      await axios.post(apiUrl.api_url + 'GetDashboardDetails/get', serchData)
       .then((response) => {
         // let res = response.data.data
           if(response.data.code===200){
             this.Total.DeliveryTotalCount = response.data.Total.DeliveryTotalCount
             this.Total.RVPTotalCount = response.data.Total.RVPTotalCount
             this.Total.DTOTotalCount = response.data.Total.DTOTotalCount
             this.Total.RTOTotalCount = response.data.Total.RTOTotalCount
             this.Delivery.AllocatedCount = response.data.Delivery.AllocatedCount
             this.Delivery.OFDCount = response.data.Delivery.OFDCount
             this.Delivery.NDRCount = response.data.Delivery.NDRCount
             this.Delivery.DeliveredCount = response.data.Delivery.DeliveredCount
             this.RVP.AllocatedCount = response.data.RVP.AllocatedCount
             this.RVP.OFDCount = response.data.RVP.OFPCount
             this.RVP.NDRCount = response.data.RVP.NPRCount
             this.RVP.PickDoneCount = response.data.RVP.PickDoneCount
             this.DTO.AllocatedCount = response.data.DTO.AllocatedCount
             this.DTO.OFDCount = response.data.DTO.OFDCount
             this.DTO.NDRCount = response.data.DTO.NDRCount
             this.DTO.DTOCount = response.data.DTO.DTOCount
             this.RTO.AllocatedCount = response.data.RTO.AllocatedCount
             this.RTO.OFDCount = response.data.RTO.OFDCount
             this.RTO.NDRCount = response.data.RTO.NDRCount
             this.RTO.RTOCount = response.data.RTO.RTOCount
           }

           this.getstatusName = getstatusName;
           if(getstatusName == 'DELIVERY'){
             this.thirdOptionForShipmentType = "Delivery"
             this.TotalCount= this.Total.DeliveryTotalCount
             this.SRallocatedCount = this.Delivery.AllocatedCount,
             this.OfdCount = this.Delivery.OFDCount,
             this.deliveryCount=this.Delivery.DeliveredCount,
             this.NdrCount = this.Delivery.NDRCount

           }else if (getstatusName == 'RVP') {
             this.thirdOptionForShipmentType = "PickDone"
             this.TotalCount= this.Total.RVPTotalCount
             this.SRallocatedCount = this.RVP.AllocatedCount,
             this.OfdCount = this.RVP.OFDCount,
             this.deliveryCount=this.RVP.PickDoneCount,
             this.NdrCount = this.RVP.NDRCount
          }else if (getstatusName == 'RTO') {
             this.thirdOptionForShipmentType = "RTO"
             this.TotalCount= this.Total.RTOTotalCount
             this.SRallocatedCount = this.RTO.AllocatedCount,
             this.OfdCount = this.RTO.OFDCount,
             this.deliveryCount=this.RTO.RTOCount,
             this.NdrCount = this.RTO.NDRCount
           }else {
             this.thirdOptionForShipmentType = "DTO"
             this.TotalCount= this.Total.DTOTotalCount
             this.SRallocatedCount = this.DTO.AllocatedCount,
             this.OfdCount = this.DTO.OFDCount,
             this.deliveryCount=this.DTO.DTOCount,
             this.NdrCount = this.DTO.NDRCount
           }

       })
       .catch((httpException) => {
           console.error('exception is:::::::::', httpException)
       })

    },

    GetTopSRList(getday){
      this.getday = getday;
      let fromdate = '';
      let todate = '';
      let monthStart = moment().startOf('month').format('YYYY-MM-DD');
      let monthEnd =  moment().endOf('month').format('YYYY-MM-DD');
      let weekStart =  moment().startOf('week').format('YYYY-MM-DD');
      let weekEnd =  moment().endOf('week').format('YYYY-MM-DD');

      if(getday == 'day'){
       fromdate = todate = moment().format('YYYY-MM-DD');
      }else if (getday == 'weekly') {
        if(monthStart > weekStart){
          fromdate = monthStart
          todate   = weekEnd
        }else if(monthEnd < weekEnd){
          fromdate = weekStart
          todate = monthEnd
        }else{
          fromdate = weekStart;
          todate   = weekEnd;
        }
      }else if (getday == 'month') {
        fromdate = monthStart
        todate   = monthEnd
      }

       let searchData = {
         "HubId": this.userHubId,
         "FromDate": fromdate,
         "ToDate": todate
       }
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'expose/get/top/sr/details',
          data: searchData
        })
        .then(result => {

          if (result.data.code == 200) {
           this.TopSRs = result.data.data
           this.IsTopSRs = true
          }
        })

    },
    loadSRList(hubid) {
      this.srLoader = this.loader
      this.srArrayList = []
      this.srList = []
      this.srListFlt = []
      if(hubid) {
        this.input = {
          "usertype":"3",
          "hubid":[hubid]
        }
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'expose/users/HubDeliveryUsers/get/List',
          data: this.input
        })
        .then(result => {
          if (result.data.data.code == 200) {
            this.srArrayList = result.data.data.results;
            for (var i = 0; i < this.srArrayList.length; i++) {
              this.srList.push({
                value: this.srArrayList[i].userid,
                text: `${this.srArrayList[i].FirstName} ${this.srArrayList[i].LastName} (${this.srArrayList[i].OldDeliveryUserOrUserId}) (${this.srArrayList[i].userid})`
              })
            }

          } else {
            this.$alertify.error(result.data.data.message?result.data.data.message:'No Record found')
          }
          this.srLoader = ''
        }, error => {
          this.srLoader = ''
          console.error(error)
        })
      } else {
        this.$alertify.error("Current Hub Id not found.")
      }
    },
    //to get client list
    getClientList() {
      axios.get(apiUrl.api_url + 'external/getclientlist', {})
        .then((response) => {
            if(response.data.code===200){

                this.clientArrayList=response.data.data;
                for (var i = 0; i < this.clientArrayList.length; i++) {
                  this.clientList.push({
                    value: this.clientArrayList[i].ClientMasterID,
                    text: `${this.clientArrayList[i].CompanyName}`
                  })
                }
            }
            else {
                this.clientList=[];
            }
        })
        .catch((httpException) => {
              this.$alertify.error("client data not found");
              console.error('exception is:::::::::', httpException)
        })
    },
    getRoleCount() {
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getrolecount',
          headers: {
            'Authorization': 'Bearer ' + this.myStr
          }
        })
        .then(result => {
          this.systemRoleCount = parseInt(result.data[1]["rolecount"]);
          this.appRoleCount = parseInt(result.data[0]["rolecount"]);
        }, error => {
          console.error(error)
        })
    },
    getUsersCount() {
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getuserscount',
          headers: {
            'Authorization': 'Bearer ' + this.myStr
          }
        })
        .then(result => {
          this.clientusers = result.data[0]['clientusercount'];
          this.adminuser = result.data[0]['admincount'];
          this.deliverycount = result.data[0]['Deliverycount'];
          this.clientvendorcount = result.data[0]['ClientVendorcount'];
        }, error => {
          console.error(error)
        })
    },

    getProjectsCount() {
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getprojectcount',
          headers: {
            'Authorization': 'Bearer ' + this.myStr
          }
        })
        .then(result => {
          this.totalProjectCount = result.data.count;
        }, error => {
          console.error(error)
        })
    },
    onSubmit: function(event) {
      this.$validator.validateAll().then(() => {
        console.log('form is valid', this.model)
        event.target.reset();
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/dashboard/dashboard.component.js